import React, { useContext, useEffect, useRef, useState } from "react";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import { useLoanCalculator } from "../../loanApplication/SummaryAndAdjust/shared/hooks/useLoanCalculator/useLoanCalculator";
import { useMultiLender } from "../../loanApplication/SummaryAndAdjust/shared/hooks/useMultiLender";
import { usePricings } from "../../loanApplication/SummaryAndAdjust/shared/hooks/usePricings";
import { useActionCallback } from "../../../../utils/hooks/useActionCallback";
import Text from "../../../shared/components/Text";

export const useQuotaAdjustment = () => {
  const {
    state: { loan },
    dispatch,
  } = useContext(ProcessContext);

  const {
    termMarks,
    minTerm,
    maxTerm,
    loanConditions,
    patchSetLoanCalculator,
    setLoanConditionsByTerm,
  } = useLoanCalculator();

  const { hasMultiplePricings, availableLenders, allLenders } = useMultiLender({
    loanConditions,
  });

  const { pricingByLoanId, requestGetPricingByLoanId } = usePricings();

  const [selectedTerm, setSelectedTerm] = useState({
    value: loanConditions.period,
    invalidNumber: false,
    invalidValue: false,
  });

  useEffect(() => {
    if (loanConditions.period > maxTerm) {
      setLoanConditionsByTerm(maxTerm);
    }
  }, [termMarks]);

  useEffect(() => {
    if (!pricingByLoanId) {
      requestGetPricingByLoanId();
    }
  }, [pricingByLoanId]);

  const termStateRef = useRef(selectedTerm.value);

  const onSubmitModule = () => {
    if (
      selectedTerm.value === loan.loan_conditions.loan_calculator.term.period
    ) {
      dispatch({
        type: "SET_FLOW_ITEM_OK",
      });
      return;
    }

    dispatch({
      type: "SET_FLOW_LOADING",
      payload: {
        show: true,
        loadingMessage: <Text tId="PLEASE_WAIT" />,
      },
    });

    patchSetLoanCalculator();
  };

  useActionCallback("REQUEST_PATCH_SET_LOAN_CALCULATOR_FULFILLED", () => {
    dispatch({
      type: "SET_FLOW_ITEM_OK",
    });
  });

  const allowedMaxTerm = maxTerm; // todo => improve
  const termOutOfScope =
    selectedTerm.value < minTerm || selectedTerm.value > allowedMaxTerm;

  const setTermStateRef = (data) => {
    termStateRef.current = data;
    setSelectedTerm({
      value: data,
      invalidNumber: isNaN(Number(data)),
      invalidValue: !filteredTermMarks.some(
        (termMark) => termMark.value === Number(data)
      ),
    });
  };

  const filteredTermMarks = termMarks?.filter(
    (mark) => mark.value <= allowedMaxTerm
  );

  const getSliderTermAndSetLoanConditions = (_, term) => {
    setTermStateRef(term);
    setLoanConditionsByTerm(term);
  };

  const invalidTerm =
    selectedTerm.invalidNumber || selectedTerm.invalidValue || termOutOfScope;

  return {
    termMarks,
    invalidTerm,
    getSliderTermAndSetLoanConditions,
    onSubmitModule,
    hasMultiplePricings,
    availableLenders,
    allLenders,
    loanConditions,
    minTerm,
    allowedMaxTerm,
    selectedTerm,
    termOutOfScope,
  };
};
